<script>
  //colocar no package.json"jspdf": "^1.3.5",
  //const jsPDF = require('jspdf')

  export default{
    props: ["attr", "label"],
    methods: {
      callPrint: function() {

        /*var specialElementHandlers = {
            '#moduleWrapper': function(element, renderer){
                return true;
            },
        };

        var doc = new jsPDF()
        // doc.text('Hello world!', 10, 10)

        doc.fromHTML($('#moduleWrapper').get(0), 15, 15, {
          'elementHandlers': specialElementHandlers
        });

        doc.save('a4.pdf');*/

        window.print();
      }
    },
    computed: {
      alingButton: function () {
        if (this.attr.alingButton) {
          return "marginTop25px"
        }
        return ""
      }
    }
  }

</script>

<template>
  <div>
    <el-button
      :class="alingButton"
      size="small"
      type="primary"
      @click.prevent="callPrint()"
      :disabled="attr.disableField"
    >
      {{label}}
    </el-button>
  </div>
</template>

<style scoped>
  .marginTop25px {
    margin-top: 25px;
  }
  .el-button {
    margin-bottom: 22px !important;
  }
</style>



// WEBPACK FOOTER //
// SgsRenderButtonPrint.vue?6b8ce6d0